import { useState } from "react";
import "../styles/form.css";

const INDIAN_CITIES = [
  "Mumbai", "Delhi", "Bengaluru", "Hyderabad", "Ahmedabad", "Chennai", "Kolkata", "Surat", "Pune", "Jaipur",
  "Lucknow", "Kanpur", "Nagpur", "Indore", "Thane", "Bhopal", "Visakhapatnam", "Pimpri-Chinchwad", "Patna", "Vadodara",
  "Ghaziabad", "Ludhiana", "Agra", "Nashik", "Faridabad", "Meerut", "Rajkot", "Kalyan-Dombivli", "Vasai-Virar", "Varanasi",
  "Srinagar", "Aurangabad", "Dhanbad", "Amritsar", "Navi Mumbai", "Allahabad", "Howrah", "Ranchi", "Gwalior", "Jabalpur",
  "Coimbatore", "Vijayawada", "Jodhpur", "Madurai", "Raipur", "Kota", "Guwahati", "Chandigarh", "Solapur", "Hubli-Dharwad",
  "Tiruchirappalli", "Bareilly", "Moradabad", "Mysore", "Tiruppur", "Gurgaon", "Aligarh", "Jalandhar", "Bhubaneswar", "Salem",
  "Mira-Bhayandar", "Warangal", "Guntur", "Bhiwandi", "Saharanpur", "Gorakhpur", "Bikaner", "Amravati", "Noida", "Jamshedpur",
  "Bhilai", "Cuttack", "Firozabad", "Kochi", "Nellore", "Bhavnagar", "Dehradun", "Durgapur", "Asansol", "Rourkela", "Nanded",
  "Kolhapur", "Ajmer", "Akola", "Gulbarga", "Jamnagar", "Ujjain", "Loni", "Siliguri", "Jhansi", "Ulhasnagar", "Jammu",
  "Sangli-Miraj & Kupwad", "Mangalore", "Erode", "Belgaum", "Ambattur", "Tirunelveli", "Malegaon", "Gaya", "Jalgaon",
  "Udaipur", "Maheshtala", "Davanagere", "Kozhikode", "Akbarpur", "Khammam", "Ozhukarai", "Bihar Sharif", "Panipat", "Darbhanga",
  "Bally", "Aizawl", "Dewas", "Ichalkaranji", "Karnal", "Bathinda", "Jalna", "Eluru", "Barasat", "Kirari Suleman Nagar",
  "Purnia", "Satna", "Mau", "Sonipat", "Farrukhabad", "Sagar", "Rourkela", "Durg", "Imphal", "Ratlam", "Hapur",
  "Anantapur", "Arrah", "Karimnagar", "Etawah", "Ambernath", "North Dumdum", "Bharatpur", "Begusarai", "New Delhi", "Gandhidham",
  "Baranagar", "Tiruvottiyur", "Pondicherry", "Sikar", "Thoothukudi", "Rewa", "Mirzapur", "Raichur", "Pali", "Ramagundam",
  "Haridwar", "Vijayanagaram", "Katihar", "Nagarcoil", "Sri Ganganagar", "Karawal Nagar", "Mango", "Thanjavur", "Bulandshahr",
  "Uluberia", "Murwara", "Sambhal", "Singrauli", "Nadiad", "Secunderabad", "Naihati", "Yamunanagar", "Bidhannagar", "Pallavaram",
  "Bidar", "Munger", "Panchkula", "Burhanpur", "Raurkela Industrial Township", "Kharagpur", "Dindigul", "Gandhinagar", "Hospet",
  "Nangloi Jat", "Malda", "Ongole", "Deoghar", "Chapra", "Haldia", "Khandwa", "Nandyal", "Morena", "Amroha", "Anand",
  "Bhind", "Bhalswa Jahangir Pur", "Madhyamgram", "Bhiwani", "Navi Mumbai Panvel Raigad", "Baharampur", "Ambala", "Morvi",
  "Fatehpur", "Rae Bareli", "Khora", "Bhusawal", "Orai", "Bahraich", "Vellore", "Mahesana", "Sambalpur", "Raiganj",
  "Sirsa", "Danapur", "Serampore", "Sultan Pur Majra", "Guna", "Jaunpur", "Panvel", "Shivpuri", "Surendranagar Dudhrej",
  "Unnao", "Hugli and Chinsurah", "Alappuzha", "Kottayam", "Palakkad", "Puri", "Punjab", "Haryana", "Maharashtra", "Gujarat",
  "Rajasthan", "Uttar Pradesh", "Madhya Pradesh", "Karnataka", "Tamil Nadu", "Kerala", "Andhra Pradesh", "Telangana", "Bihar"
];

export default function RegistrationForm() {
  const [form, setForm] = useState({
    FullName: "",
    age: "",
    email: "",
    phone: "",
    parentName: "",
    parentPhone: "",
    source: "",
    birthYear: "",
    class: "",
    schoolName: "",
    location: "",
    preferredLanguage: ""
  });

  const [errors, setErrors] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [apiError, setApiError] = useState("");
  const [showYearDropdown, setShowYearDropdown] = useState(false);
  const [showStdDropdown, setShowStdDropdown] = useState(false);
  const [showAgeDropdown, setShowAgeDropdown] = useState(false);
  const [showSourceDropdown, setShowSourceDropdown] = useState(false);
  const [showLangDropdown, setShowLangDropdown] = useState(false);
  const [showLocationDropdown, setShowLocationDropdown] = useState(false);
  const [locationSuggestions, setLocationSuggestions] = useState([]);


  const currentYear = new Date().getFullYear();
  let yearsList = [];
  if (form.age === "12-18") {
    const startYear = currentYear - 18;
    yearsList = Array.from({ length: 7 }, (_, i) => startYear + i).reverse();
  } else if (form.age === "18-28") {
    const startYear = currentYear - 28;
    yearsList = Array.from({ length: 11 }, (_, i) => startYear + i).reverse();
  } else if (form.age === "28+") {
    const endYear = currentYear - 28;
    yearsList = Array.from({ length: 40 }, (_, i) => endYear - i);
  } else {
    yearsList = Array.from({ length: 77 }, (_, i) => currentYear - i);
  }

  const allStdOptions = [
    { group: "School Students", options: ["Class 6", "Class 7", "Class 8", "Class 9", "Class 10", "Class 11", "Class 12"] },
    { group: "College Students", options: ["Diploma", "Undergraduate", "Postgraduate", "Enginering"] },
    { group: "Professionals", options: ["Working Professional", "Job Seeker", "Entrepreneur"] }
  ];

  let filteredStdOptions = [];
  if (form.age === "12-18") {
    filteredStdOptions = allStdOptions.filter(g => g.group === "School Students");
  } else if (form.age === "18-28") {
    filteredStdOptions = allStdOptions.filter(g => g.group === "College Students" || g.group === "Professionals");
  } else if (form.age === "28+") {
    filteredStdOptions = allStdOptions.filter(g => g.group === "Professionals");
  } else {
    filteredStdOptions = allStdOptions;
  }

  let institutionLabel = "School / College / Company Name";
  let institutionPlaceholder = "Your Institution Name";
  if (form.age === "12-18") {
    institutionLabel = "School Name";
    institutionPlaceholder = "Your School Name";
  } else if (form.age === "18-28") {
    const isProfessional = allStdOptions[2].options.includes(form.class);
    if (isProfessional) {
      institutionLabel = "Company Name";
      institutionPlaceholder = "Your Company Name";
    } else {
      institutionLabel = "College Name";
      institutionPlaceholder = "Your College Name";
    }
  } else if (form.age === "28+") {
    institutionLabel = "Company Name";
    institutionPlaceholder = "Your Company Name";
  }

  const validateField = (name, value) => {
    if (!value) return "This field is required";

    if (name === "name" || name === "parentName") {
      if (/[^a-zA-Z\s]/.test(value)) {
        return "Must contain only letters and spaces";
      }
      if (name === "parentName" && value.length > 30) {
        return "Must be 30 characters or less";
      }
    }

    if (name === "email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(value)) {
        return "Must be a valid email address";
      }
    }

    if (name === "phone" || name === "parentPhone") {
      if (!/^\d{10}$/.test(value)) {
        return "Must be exactly 10 digits";
      }
    }
    return null;
  };

  const validate = () => {
    let tempErrors = {};
    const fieldsToValidate = ["name", "email", "phone", "parentName", "parentPhone", "age", "birthYear", "class", "location", "schoolName", "preferredLanguage", "source"];

    fieldsToValidate.forEach(key => {
      const error = validateField(key, form[key]);
      if (error) tempErrors[key] = error;
    });

    setErrors(tempErrors);

    if (Object.keys(tempErrors).length > 0) {
      console.log("Validation Failed! Here are the specific fields missing or invalid:", tempErrors);
    }

    return Object.keys(tempErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let newValue = value;

    // Prevent typing numbers or special characters in name fields
    if (name === "name" || name === "parentName") {
      newValue = value.replace(/[^a-zA-Z\s]/g, '');
      if (name === "parentName") {
        newValue = newValue.slice(0, 30);
      }
    }

    // Prevent typing non-digits and limit to 10 for phone fields
    if (name === "phone" || name === "parentPhone") {
      newValue = value.replace(/\D/g, '').slice(0, 10);
    }

    let updates = { [name]: newValue };

    if (name === "location") {
      if (newValue.length > 0) {
        const matches = INDIAN_CITIES.filter(city => city.toLowerCase().includes(newValue.toLowerCase())).slice(0, 5);
        setLocationSuggestions(matches);
        setShowLocationDropdown(true);
      } else {
        setShowLocationDropdown(false);
      }
    }

    // Reset dependent fields when age changes
    if (name === "age") {
      updates.birthYear = "";
      updates.class = "";
      updates.schoolName = "";
      setErrors(prev => ({ ...prev, birthYear: null, class: null, schoolName: null }));
    } else if (name === "class") {
      updates.schoolName = "";
      setErrors(prev => ({ ...prev, schoolName: null }));
    }

    setForm(prev => ({ ...prev, ...updates }));

    // Auto-remove error when correcting input
    if (errors[name]) {
      const error = validateField(name, newValue);
      setErrors(prev => ({ ...prev, [name]: error }));
    }
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    const error = validateField(name, value);
    setErrors(prev => ({ ...prev, [name]: error }));
  };

  // API storage connection backend
  const handleSubmit = async (e) => {
    e.preventDefault();
    setApiError("");
    console.log("Submit button clicked! Running validation...");

    if (!validate()) {
      console.log("Validation failed! Please check the red error messages on the form.");

      // Get the current errors state immediately (since setErrors is async)
      const fieldsToValidate = ["name", "email", "phone", "parentName", "parentPhone", "age", "birthYear", "class", "location", "schoolName", "preferredLanguage", "source"];
      let tempErrors = {};
      fieldsToValidate.forEach(key => {
        const error = validateField(key, form[key]);
        if (error) tempErrors[key] = error;
      });

      const missingFields = Object.keys(tempErrors).map(key => `${key}: ${tempErrors[key]}`).join("\n");
      alert("⚠️ Cannot Submit Form! ⚠️\n\nThe following fields are missing or invalid:\n\n" + missingFields + "\n\nPlease fix these fields and try again.");
      return;
    }

    console.log("Validation passed! Sending request to API...");
    setIsSubmitting(true);
    try {
      const payload = { ...form };
      const res = await fetch("https://tdtlworld.com/workshop_registration-backend/api/register/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
      });

      console.log("API Response Status:", res.status);
      if (!res.ok) {
        throw new Error("Failed to register. Please try again.");
      }

      await res.json();
      console.log("Registration completely successful!");
      setIsSubmitted(true);

      // Reset form after success
      setForm({
        name: "",
        age: "",
        email: "",
        phone: "",
        parentName: "",
        parentPhone: "",
        source: "",
        birthYear: "",
        class: "",
        schoolName: "",
        location: "",
        preferredLanguage: ""
      });

      setErrors({});
    } catch (error) {
      console.error("Fetch Error:", error);

      // If it's a TypeError, it's almost certainly CORS or network failure
      if (error.name === "TypeError" && error.message === "Failed to fetch") {
        setApiError("CORS ERROR: Your browser blocked this request to tdtlworld.com. Check the Console (F12) for details.");
        alert("🚨 CORS ERROR DETECTED 🚨\n\nThe browser blocked the request from localhost to tdtlworld.com for security reasons.\n\nYou MUST enable CORS on your backend server to fix this!");
      } else {
        setApiError(error.message || "Error submitting form. Please check your connection.");
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="registration-panel glass-reflection">
      {isSubmitted ? (
        <div className="success-message-container" style={{ textAlign: "center", padding: "60px 20px" }}>
          <div style={{ marginBottom: "25px", display: "flex", justifyContent: "center" }}>
            <svg viewBox="0 0 24 24" fill="none" stroke="#39ff14" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{ width: "90px", height: "90px", filter: "drop-shadow(0 0 10px rgba(57, 255, 20, 0.8)) drop-shadow(0 0 20px rgba(57, 255, 20, 0.6))" }}>
              <circle cx="12" cy="12" r="10"></circle>
              <polyline points="8 12 11 15 16 9"></polyline>
            </svg>
          </div>
          <h2 style={{ color: "white", marginBottom: "15px", fontSize: "28px" }}>Registration Successful!</h2>
          <p style={{ color: "#aaa", marginBottom: "30px", fontSize: "16px" }}>We have successfully received your details. Thank you!</p>
          <button type="button" onClick={() => setIsSubmitted(false)} className="initial-btn" style={{ width: "auto", padding: "12px 40px" }}>
            REGISTER AGAIN
          </button>
        </div>
      ) : (
        <>
          <div className="panel-header">
            <h3 className="form-title">Secure Your Spot</h3>
            <p className="form-subtitle">Initialize your registration </p>
          </div>

          <form onSubmit={handleSubmit} className="registration-grid" noValidate>
            <div className="input-block full-width">
              <label>Full Name</label>
              <div className="input-wrapper">
                <svg className="input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                <input type="text" name="name" placeholder="John Doe" value={form.name} onChange={handleChange} onBlur={handleBlur} className={errors.name ? "error-input" : ""} />
              </div>
              {errors.name && <span className="error-text">{errors.name}</span>}
            </div>

            <div className="input-block half-width">
              <label>Email Address</label>
              <div className="input-wrapper">
                <svg className="input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
                <input type="email" name="email" placeholder="john@example.com" value={form.email} onChange={handleChange} onBlur={handleBlur} className={errors.email ? "error-input" : ""} />
              </div>
              {errors.email && <span className="error-text">{errors.email}</span>}
            </div>

            <div className="input-block half-width">
              <label>Phone Number</label>
              <div className="input-wrapper">
                <svg className="input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
                <input type="tel" name="phone" placeholder="+91 XXXXXXXXXX" value={form.phone} onChange={handleChange} onBlur={handleBlur} className={errors.phone ? "error-input" : ""} />
              </div>
              {errors.phone && <span className="error-text">{errors.phone}</span>}
            </div>

            <div className="input-block half-width">
              <label>Parent's Name</label>
              <div className="input-wrapper">
                <svg className="input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                <input type="text" name="parentName" maxLength="30" placeholder="Parent / Guardian Name" value={form.parentName} onChange={handleChange} onBlur={handleBlur} className={errors.parentName ? "error-input" : ""} />
              </div>
              {errors.parentName && <span className="error-text">{errors.parentName}</span>}
            </div>

            <div className="input-block half-width">
              <label>Parent's Phone Number</label>
              <div className="input-wrapper">
                <svg className="input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
                <input type="tel" name="parentPhone" placeholder="+91 XXXXXXXXXX" value={form.parentPhone} onChange={handleChange} onBlur={handleBlur} className={errors.parentPhone ? "error-input" : ""} />
              </div>
              {errors.parentPhone && <span className="error-text">{errors.parentPhone}</span>}
            </div>

            <div className="input-block half-width custom-dropdown-container">
              <label> Your Age</label>
              <div className="input-wrapper custom-select-wrapper" onClick={() => setShowAgeDropdown(!showAgeDropdown)}>
                <svg className="input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path><polyline points="23 4 23 10 17 10"></polyline><text x="12" y="15" fontSize="7" fontWeight="bold" fill="currentColor" stroke="none" textAnchor="middle">Age</text></svg>
                <div style={{
                  width: '100%',
                  background: 'rgba(11, 14, 20, 0.7)',
                  border: errors.age ? '1px solid #FB7185' : '1px solid rgba(255, 255, 255, 0.1)',
                  borderRadius: '8px',
                  padding: '10px 14px 10px 42px',
                  color: form.age ? '#fff' : '#4A5568',
                  fontSize: '0.95rem',
                  cursor: 'pointer',
                  boxSizing: 'border-box',
                  transition: 'all 0.3s ease'
                }}>
                  {form.age || "select age"}
                </div>
              </div>
              {errors.age && <span className="error-text">{errors.age}</span>}
              {showAgeDropdown && <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 90 }} onClick={(e) => { e.stopPropagation(); setShowAgeDropdown(false); }}></div>}
              {showAgeDropdown && (
                <ul className="custom-year-dropdown" style={{ zIndex: 100 }}>
                  {["12-18", "18-28", "28+"].map(opt => (
                    <li key={opt} onClick={() => {
                      handleChange({ target: { name: 'age', value: opt } });
                      setShowAgeDropdown(false);
                    }}>
                      {opt}
                    </li>
                  ))}
                </ul>
              )}
            </div>

            <div className="input-block half-width custom-dropdown-container">
              <label>Birth Year</label>
              <div className="input-wrapper custom-select-wrapper" onClick={() => setShowYearDropdown(!showYearDropdown)}>
                <svg className="input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>
                <div style={{
                  width: '100%',
                  background: 'rgba(11, 14, 20, 0.7)',
                  border: errors.birthYear ? '1px solid #FB7185' : '1px solid rgba(255, 255, 255, 0.1)',
                  borderRadius: '8px',
                  padding: '10px 14px 10px 42px',
                  color: form.birthYear ? '#fff' : '#4A5568',
                  fontSize: '0.95rem',
                  cursor: 'pointer',
                  boxSizing: 'border-box',
                  transition: 'all 0.3s ease'
                }}>
                  {form.birthYear || "Select Year"}
                </div>
              </div>
              {errors.birthYear && <span className="error-text">{errors.birthYear}</span>}

              {showYearDropdown && <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 90 }} onClick={(e) => { e.stopPropagation(); setShowYearDropdown(false); }}></div>}
              {showYearDropdown && (
                <ul className="custom-year-dropdown" style={{ zIndex: 100 }}>
                  {yearsList.map(year => (
                    <li key={year} onClick={() => {
                      handleChange({ target: { name: 'birthYear', value: year.toString() } });
                      setShowYearDropdown(false);
                    }}>
                      {year}
                    </li>
                  ))}
                </ul>
              )}
            </div>

            <div className="input-block half-width custom-dropdown-container">
              <label>Class</label>
              <div className="input-wrapper custom-select-wrapper modern-select-wrapper" onClick={() => setShowStdDropdown(!showStdDropdown)}>
                <svg className="input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 10v6M2 10l10-5 10 5-10 5z"></path><path d="M6 12v5c3 3 9 3 12 0v-5"></path></svg>
                <div style={{
                  width: '100%',
                  background: 'rgba(11, 14, 20, 0.7)',
                  border: errors.class ? '1px solid #FB7185' : '1px solid rgba(255, 255, 255, 0.1)',
                  borderRadius: '8px',
                  padding: '10px 14px 10px 42px',
                  color: form.class ? '#fff' : '#4A5568',
                  fontSize: '0.95rem',
                  cursor: 'pointer',
                  boxSizing: 'border-box',
                  transition: 'all 0.3s ease'
                }}>
                  {form.class || "Select your profile"}
                </div>
                <svg className="dropdown-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
              </div>
              {errors.class && <span className="error-text">{errors.class}</span>}

              {showStdDropdown && <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 90 }} onClick={(e) => { e.stopPropagation(); setShowStdDropdown(false); }}></div>}
              {showStdDropdown && (
                <ul className="custom-std-dropdown" style={{ zIndex: 100 }}>
                  {filteredStdOptions.map((group) => (
                    <div key={group.group}>
                      <li className="dropdown-group-label">{group.group}</li>
                      {group.options.map(opt => (
                        <li key={opt} onClick={() => {
                          handleChange({ target: { name: 'class', value: opt } });
                          setShowStdDropdown(false);
                        }}>
                          {opt}
                        </li>
                      ))}
                    </div>
                  ))}
                </ul>
              )}
            </div>

            <style>{`
              @keyframes spin { 100% { transform: rotate(360deg); } }
              .location-dropdown li:hover { background: rgba(57, 255, 20, 0.1); color: #fff; cursor: pointer; }
              .location-dropdown li { padding: 10px 14px; transition: all 0.2s; border-bottom: 1px solid rgba(255, 255, 255, 0.05); }
              .location-dropdown li:last-child { border-bottom: none; }
            `}</style>
            <div className="input-block half-width" style={{ position: 'relative' }}>
              <label>Location</label>
              <div className="input-wrapper">
                <svg className="input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
                <input
                  type="text"
                  name="location"
                  placeholder="City / Area"
                  value={form.location}
                  onChange={handleChange}
                  onFocus={() => setShowLocationDropdown(true)}
                  onBlur={(e) => {
                    handleBlur(e);
                    setTimeout(() => setShowLocationDropdown(false), 200);
                  }}
                  className={errors.location ? "error-input" : ""}
                  autoComplete="off"
                />
              </div>
              {errors.location && <span className="error-text">{errors.location}</span>}
              {showLocationDropdown && (
                <ul className="custom-year-dropdown location-dropdown" style={{ zIndex: 100, maxHeight: '250px', overflowY: 'auto' }}>

                  {locationSuggestions.length > 0 && <li style={{ pointerEvents: 'none', background: 'transparent', padding: '4px 14px', fontSize: '0.8rem', color: '#a0aec0', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Suggestions</li>}
                  {locationSuggestions.map(city => (
                    <li key={city} onClick={() => {
                      setForm(prev => ({ ...prev, location: city }));
                      setErrors(prev => ({ ...prev, location: null }));
                      setShowLocationDropdown(false);
                    }}>
                      <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="#a0aec0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '8px', display: 'inline-block', verticalAlign: 'middle' }}><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
                      {city.toLowerCase().includes(form.location.toLowerCase()) && form.location.length > 0 ? (
                        <>
                          {city.substring(0, city.toLowerCase().indexOf(form.location.toLowerCase()))}
                          <span style={{ color: '#fff', fontWeight: 'bold' }}>{city.substring(city.toLowerCase().indexOf(form.location.toLowerCase()), city.toLowerCase().indexOf(form.location.toLowerCase()) + form.location.length)}</span>
                          {city.substring(city.toLowerCase().indexOf(form.location.toLowerCase()) + form.location.length)}
                        </>
                      ) : city}
                    </li>
                  ))}
                  {locationSuggestions.length === 0 && form.location.length > 0 && !INDIAN_CITIES.find(c => c.toLowerCase() === form.location.toLowerCase()) && (
                    <li onClick={() => setShowLocationDropdown(false)}>
                      <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="#a0aec0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '8px', display: 'inline-block', verticalAlign: 'middle' }}><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
                      {form.location} (Use as entered)
                    </li>
                  )}
                </ul>
              )}
            </div>

            <div className="input-block full-width">
              <label>{institutionLabel}</label>
              <div className="input-wrapper">
                <svg className="input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>
                <input type="text" name="schoolName" placeholder={institutionPlaceholder} value={form.schoolName} onChange={handleChange} onBlur={handleBlur} className={errors.schoolName ? "error-input" : ""} />
              </div>
              {errors.schoolName && <span className="error-text">{errors.schoolName}</span>}
            </div>

            <div className="input-block half-width" style={{ position: 'relative' }}>
              <label>Preferred Language</label>
              <div className="input-wrapper custom-select-wrapper" onClick={() => setShowLangDropdown(!showLangDropdown)}>
                <svg className="input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"></circle><line x1="2" y1="12" x2="22" y2="12"></line><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path></svg>
                <div style={{
                  width: '100%',
                  background: 'rgba(11, 14, 20, 0.7)',
                  border: errors.preferredLanguage ? '1px solid #FB7185' : '1px solid rgba(255, 255, 255, 0.1)',
                  borderRadius: '8px',
                  padding: '10px 14px 10px 42px',
                  color: form.preferredLanguage ? '#fff' : '#4A5568',
                  fontSize: '0.95rem',
                  cursor: 'pointer',
                  boxSizing: 'border-box',
                  transition: 'all 0.3s ease'
                }}>
                  {form.preferredLanguage || "Select Language"}
                </div>
              </div>
              {errors.preferredLanguage && <span className="error-text">{errors.preferredLanguage}</span>}
              {showLangDropdown && <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 90 }} onClick={(e) => { e.stopPropagation(); setShowLangDropdown(false); }}></div>}
              {showLangDropdown && (
                <ul className="custom-year-dropdown" style={{ zIndex: 100 }}>
                  {["English", "Hindi", "Marathi"].map(opt => (
                    <li key={opt} onClick={() => {
                      handleChange({ target: { name: 'preferredLanguage', value: opt } });
                      setShowLangDropdown(false);
                    }}>
                      {opt}
                    </li>
                  ))}
                </ul>
              )}
            </div>

            <div className="input-block half-width" style={{ position: 'relative' }}>
              <label>Discovered Via</label>
              <div className="input-wrapper custom-select-wrapper" onClick={() => setShowSourceDropdown(!showSourceDropdown)}>
                <svg className="input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
                <div style={{
                  width: '100%',
                  background: 'rgba(11, 14, 20, 0.7)',
                  border: errors.source ? '1px solid #FB7185' : '1px solid rgba(255, 255, 255, 0.1)',
                  borderRadius: '8px',
                  padding: '10px 14px 10px 42px',
                  color: form.source ? '#fff' : '#4A5568',
                  fontSize: '0.95rem',
                  cursor: 'pointer',
                  boxSizing: 'border-box',
                  transition: 'all 0.3s ease'
                }}>
                  {form.source || "Select Source"}
                </div>
              </div>
              {errors.source && <span className="error-text">{errors.source}</span>}
              {showSourceDropdown && <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 90 }} onClick={(e) => { e.stopPropagation(); setShowSourceDropdown(false); }}></div>}
              {showSourceDropdown && (
                <ul className="custom-year-dropdown" style={{ zIndex: 100 }}>
                  {["Instagram", "LinkedIn", "WhatsApp", "Facebook", "Other"].map(opt => (
                    <li key={opt} onClick={() => {
                      handleChange({ target: { name: 'source', value: opt } });
                      setShowSourceDropdown(false);
                    }}>
                      {opt}
                    </li>
                  ))}
                </ul>
              )}
            </div>

            {/* <div className="input-block full-width group-radio">
              <label className="radio-main-label">Are you Looking for the future in AI?</label>
              <div className="radio-options-flex">
                <label className="custom-radio-v2">
                  <input type="radio" name="aiInterest" value="yes" checked={form.aiInterest === "yes"} onChange={handleChange} />
                  <div className="radio-outer">
                    <div className="radio-inner"></div>
                  </div>
                  <span className="radio-text">Yes, absolutely</span>
                </label>
                <label className="custom-radio-v2">
                  <input type="radio" name="aiInterest" value="no" checked={form.aiInterest === "no"} onChange={handleChange} />
                  <div className="radio-outer">
                    <div className="radio-inner"></div>
                  </div>
                  <span className="radio-text">No, just starting</span>
                </label>
              </div>
              {errors.aiInterest && <span className="error-text" style={{ marginTop: '8px' }}>{errors.aiInterest}</span>}
            </div> */}

            <div className="form-submit full-width">
              {apiError && <div style={{ color: '#e53e3e', marginBottom: '15px', textAlign: 'center', fontSize: '0.9rem', fontWeight: '500' }}>{apiError}</div>}
              <button type="submit" className="initial-btn" disabled={isSubmitting} style={{ opacity: isSubmitting ? 0.7 : 1, cursor: isSubmitting ? 'not-allowed' : 'pointer' }}>
                {isSubmitting ? "PROCESSING..." : "INITIALIZE REGISTRATION \u2192"}
              </button>
            </div>
          </form>
        </>
      )}
    </div>
  );
}